import { useParams, Link } from "react-router-dom";
import { MapPin, Wallet, Sparkles, Star, ArrowLeft, Search } from "lucide-react";
import { usePublicSiteCms } from "@/lib/siteCms";

const ICONS = { lokasi: MapPin, harga: Wallet, fasilitas: Sparkles, rating: Star };

function renderContent(text) {
  if (!text) return null;
  const blocks = text.split(/\n\s*\n/);
  return blocks.map((block, bi) => {
    const lines = block.split("\n").map((l) => l.trim()).filter(Boolean);
    const bullets = lines.filter((l) => l.startsWith("- ") || l.startsWith("• "));
    if (bullets.length && bullets.length === lines.length) {
      return (
        <ul key={bi} className="list-disc pl-5 space-y-1.5 text-muted-foreground">
          {lines.map((l, i) => <li key={i}>{l.replace(/^[-•]\s*/, "")}</li>)}
        </ul>
      );
    }
    return (
      <p key={bi} className="text-muted-foreground leading-relaxed">
        {lines.map((l, i) => (
          <span key={i}>{l}{i < lines.length - 1 && <br />}</span>
        ))}
      </p>
    );
  });
}

export default function WhyAvasaDetailPage() {
  const { key } = useParams();
  const cms = usePublicSiteCms();
  const cards = cms?.why_avasa_cards || [];
  const card = cards.find((c) => c.key === key);
  const Icon = ICONS[key] || Sparkles;

  if (cms && !card) {
    return (
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center" data-testid="why-detail-notfound">
        <h1 className="font-heading text-3xl font-bold">Halaman tidak ditemukan</h1>
        <Link to="/" className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-primary hover:underline">
          <ArrowLeft size={15} /> Kembali ke Beranda
        </Link>
      </div>
    );
  }

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid={`why-detail-${key}`}>
      <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground mb-6" data-testid="why-detail-back">
        <ArrowLeft size={15} /> Kembali ke Beranda
      </Link>
      <div className="flex items-center gap-2 text-primary mb-3">
        <span className="text-xs uppercase tracking-widest font-semibold">Kenapa AVASA</span>
      </div>
      <div className="flex items-center gap-4 mb-6">
        <span className="grid place-items-center w-14 h-14 rounded-2xl bg-secondary text-primary shrink-0"><Icon size={26} /></span>
        <h1 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight" data-testid="why-detail-title">
          {card?.detail_title || card?.title || ""}
        </h1>
      </div>
      <div className="mt-2 space-y-4" data-testid="why-detail-content">
        {renderContent(card?.detail_content || card?.desc)}
      </div>
      <div className="mt-10">
        <Link to="/search" data-testid="why-detail-cta"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-accent text-accent-foreground font-semibold hover:scale-[1.02] active:scale-95 transition-transform">
          <Search size={17} /> Mulai Cari Hunian
        </Link>
      </div>
    </div>
  );
}
